import React, { useEffect } from 'react';
import '../../App.css';
import kookalBg from '../../assets/kookal_1.jpg';

import mainBg from '../../assets/Avothar-Kodaikanal-1.png';
import cartageBg from '../../assets/Avothar-Kodaikanal-Cartage.jpg';
import hikeBg from '../../assets/Avothar-hikeday-background.jpg';
import offroadBg from '../../assets/Avothar-OffRoad-Jeep.png';
import '../../fonts/MontagnaLTD.ttf';
import Navbar from '../../components/common/Navbar/Navbar';
import Footer from '../../components/common/Footer/Footer';
import 'animate.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import logo from '../../assets/Avothar-black-logo.png'
import { NavLink } from 'react-router-dom';



function Home() {

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <Navbar position="absolute" logo = {logo} buttonColor='dark' border="bottom" navColor="black" color="black"/>
      <section className="main-section pb-5 " id="main-section" style={{ backgroundImage: `url(${kookalBg})` ,backgroundPosition:"top"}}>
        <div className="container landing-margin  " data-aos="zoom-in-right" data-aos-duration="3000">
          <div className="">
            <div className="row pb-3">
              <div className="col-lg-7 ps-3 pt-4 ">
               
              </div>
              <div className="col-lg-5 pt-2">
                <h1 style={{    color: "beige",textShadow: "3px 3px 17px black"}} className="hero-heading mb-3">
                  <span style={{ fontSize: '6rem' }}>Luxurious</span> <br />
                  <span style={{ fontSize: '1.6rem' }}>Gated Comunity Villa Plots</span><br></br>
                  <span style={{ fontSize: '1.6rem' }}>Kookal Kodaikanal</span>
                </h1>
                 <NavLink
                  to="/kookal" className="mt-5">
  
                                  <span className="explore-btn ms-md-4 mt-3 square td-middling">EXPLORE</span>

              </NavLink>
              </div>
            </div>

          
          </div>
        </div>
      </section>
       <div className="container mt-5 mb-5 icon-session center">
        <div className="row">
          <div className="col-sm-12 col-lg-3" data-aos="fade-right">
            <i class="fa-solid fa-mountain-sun icon"></i>
            <div style={{ fontFamily: "'Poppins', sans-serif", paddingBottom: 8, fontWeight: 700, fontSize: '1.1rem' }} >
             Premium Gated Community
            </div>
            <p style={{ fontSize: '1.1rem' }}>
            Live in a secure, private, and nature-rich neighborhood.
            </p>
          </div>
          <div className="col-sm-12 col-lg-3" data-aos="fade-up">
            <i class="fa-solid fa-road icon"></i>
            <div style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, paddingBottom: 8, fontSize: '1.1rem' }}>
              7.2-Meter Internal Roads
            </div>
            <p style={{ fontSize: '1.1rem' }}>
              Wide, well-planned roads for easy access and comfort.
            </p>
          </div>
          <div className="col-sm-12 col-lg-3" data-aos="fade-left">
            <i class="fa-sharp fa-solid fa-water icon"></i>
            <div style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, paddingBottom: 8, fontSize: '1.1rem' }}>
             Ready Electricity & Water
            </div>
            <p style={{ fontSize: '1.1rem' }}>
              Fully equipped with essential utilities from day one.
            </p>
          </div>
           <div className="col-sm-12 col-lg-3" data-aos="fade-left">
            <i class="fa-sharp fa-solid fa-home icon"></i>
            <div style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, paddingBottom: 8, fontSize: '1.1rem' }}>
             Dream Villas & Smart Investments
            </div>
            <p style={{ fontSize: '1.1rem' }}>
              Perfect to build your villa or grow your wealth.
            </p>
          </div>
        </div>
      </div>
      <section className="main-section pb-5 " id="main-section" style={{ backgroundImage: `url(${mainBg})` }}>
        <div className="container mx-md-5 landing-margin  " data-aos="zoom-in-right" data-aos-duration="3000">
          <div className="content-blur-container ">
            <div className="row blur-content pb-3">
              <div className="col-lg-4 ps-3 pt-4 ">
                <h1 className="hero-heading">
                  <span style={{ fontSize: '2.35rem' }}>POOMBARAI</span> <br />
                  <span style={{ fontSize: '4rem' }}>FARMS</span>
                </h1>
              </div>
              <div className="col-lg-8 pt-2">
                <p className="description" style={{ fontSize: '1.35rem' }}>
                  Tucked away in the misty hills of Kodaikanal, our farms offer
                  more than just land—they offer serenity. Walk through lush
                  avocado orchards, breathe in the mountain air, and
                  reconnect with nature in its purest form.
                </p>
              </div>
            </div>

            <div className='text-align-btn'>
              <a target="_blank" href="https://kodaiagriorg.com/" rel="noreferrer">
                <button type="button" className="explore-btn ms-md-4 mt-3 square td-middling">EXPLORE</button>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="container icon-session center">
        <div className="row">
          <div className="col-sm-12 col-lg-4" data-aos="fade-right">
            <i class="fa-solid fa-truck-monster icon"></i>
            <div style={{ fontFamily: "'Poppins', sans-serif", paddingBottom: 8, fontWeight: 700, fontSize: '1.1rem' }} >
              MOST POPULAR ACTIVITY
            </div>
            <p style={{ fontSize: '1.1rem' }}>
              Trek or go off-road to visit our farm lands nestled in nature
            </p>
          </div>
          <div className="col-sm-12 col-lg-4 " data-aos="fade-up">
            <i class="fa-solid fa-mountain-sun icon"></i>
            <div style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, paddingBottom: 8, fontSize: '1.1rem' }}>
              WHY VISIT?
            </div>
            <p style={{ fontSize: '1.1rem' }}>
              Perfect for weekend escapes, eco-living, and mountain serenity
            </p>
          </div>
          <div className="col-sm-12 col-lg-4 " data-aos="fade-left">
            <i class="fa-sharp fa-solid fa-tree icon"></i>
            <div style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, paddingBottom: 8, fontSize: '1.1rem' }}>
              BUY FARM LAND
            </div>
            <p style={{ fontSize: '1.1rem' }}>
              Become a proud owner of your "Peace of Land" in Poombarai.
            </p>
          </div>
        </div>
      </div>

      <section className="second-section pb-3 position-relative" id="second-section">
        <div className="absolute-1">
          <div className="rotate" >
            <h4 className="hike" data-aos="fade-right">KODAIKANAL</h4>
            <h3 className="camp" data-aos="fade-left">STAYS</h3>
          </div>
          <div className="d-flex justify-content-center" data-aos="zoom-in-right">
            <a target="_blank" href="https://booking.avothar.com/" rel="noreferrer">
              <button type="button" className="explore-btn btn-enquire">Book Now</button>
            </a>
          </div>
        </div>
        <div className="container-fluid cartage-background" style={{ backgroundImage: `url(${cartageBg})` }}></div>
        <div className="container px-5 py-3">
          <div className="cartage-description py-4" style={{ fontSize: '1.3rem' }}>
            Unwind in the heart of nature with charming villa-style accommodations, perfect for peaceful getaways,
            family vacations, or remote work escapes. Wake up to misty mornings, lush green views, and fresh
            mountain air.
          </div>
          <div className="cartage-section-2">
            <h6 className='title'>PROPERTY FEATURES</h6>
            <div className="row">
              <div className="col-md-4">
                <h6><i class="fa-solid fa-square-check px-2" style={{ color: "green" }}></i>8 Suite Rooms</h6>
                <h6><i class="fa-solid fa-square-check px-2" style={{ color: "green" }}></i>Home Food</h6>
              </div>
              <div className="col-md-4">
                <h6><i class="fa-solid fa-square-check px-2" style={{ color: "green" }}></i>24 Hours Hot Water</h6>
                <h6><i class="fa-solid fa-square-check px-2" style={{ color: "green" }}></i>Camp Fire</h6>
              </div>
              <div className="col-md-4">
                <h6><i class="fa-solid fa-square-check px-2" style={{ color: "green" }}></i>Car Parking</h6>
                <h6><i class="fa-solid fa-square-check px-2" style={{ color: "green" }}></i>Spacious Lawn</h6>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="third-section pb-3 position-relative" id="third-section">
        <div className="absolute">
          <div className="rotate" >
            <h4 className="hike" data-aos="fade-right">HIKE & DAY</h4>
            <h3 className="camp" data-aos="fade-left">CAMP</h3>
          </div>
          <div className="d-flex justify-content-center" data-aos="zoom-in-left">
            <a target="_blank" href="https://kodaiagriorg.com/" rel="noreferrer">
              <button type="button" className="explore-btn btn-enquire">ENQUIRE</button>
            </a>
          </div>
        </div>
        <div className="container-fluid hikeday-background" style={{ backgroundImage: `url(${hikeBg})` }}></div>
        <div className="container  py-3 move-right">
          <div className="cartage-description py-4 w-100" style={{ fontSize: '1.3rem' }}>
            Experience an unforgettable Hike & Day Camp in the scenic hills of Kodaikanal — complete with a visit to
            our peaceful Avocado Farms. Trek lush trails, camp under the open sky, and enjoy hands-on planting
            activities in nature.
          </div>
          <div className="cartage-section-2 w-100">
            <h6 className='title'>Activites</h6>
            <div className="row">
              <div className="col-md-4">
                <h6><i class="fa-solid fa-square-check px-2" style={{ color: "green" }}></i>Guided Hikes</h6>
                <h6><i class="fa-solid fa-square-check px-2" style={{ color: "green" }}></i>Tree Planting</h6>
              </div>
              <div className="col-md-4">
                <h6><i class="fa-solid fa-square-check px-2" style={{ color: "green" }}></i>Scenic Camping</h6>
                <h6><i class="fa-solid fa-square-check px-2" style={{ color: "green" }}></i>Local Refreshments</h6>
              </div>
              <div className="col-md-4">
                <h6><i class="fa-solid fa-square-check px-2" style={{ color: "green" }}></i>Avocado Farm</h6>
                <h6><i class="fa-solid fa-square-check px-2" style={{ color: "green" }}></i>Nature Stories</h6>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fourth-section pb-3 position-relative" id="fourth-section">
        <div className="absolute-3">
          <div className="rotate">
            <h4 className="hike" data-aos="fade-right">ADVENTURE</h4>
            <h3 className="camp" data-aos="fade-left">OFFROAD</h3>
          </div>
          <div className="d-flex justify-content-center" data-aos="zoom-in-down">
            <a target="_blank" href="https://kodaiagriorg.com/tour-our-farm/" rel="noreferrer">
              <button type="button" className="explore-btn btn-enquire">ENQUIRE</button>
            </a>
          </div>
        </div>
        <div className="container-fluid off-road-background" style={{ backgroundImage: `url(${offroadBg})` }}></div>
        <div className="container  py-3">
          <div className="cartage-description py-4" style={{ fontSize: '1.3rem' }}>
            Book your wildest ride through Kodaikanal & Poombarai's rugged trails and hidden forest routes.
            Experience nature like never before — from behind the wheel of adventure.
          </div>
          <div className="cartage-section-2 ">
            <h6 className='title'>OFFROAD</h6>
            <div className="row">
              <div className="col-md-4">
                <h6><i class="fa-solid fa-square-check px-2" style={{ color: "green" }}></i>Mountain Trails</h6>
                <h6><i class="fa-solid fa-square-check px-2" style={{ color: "green" }}></i>Hidden Valleys</h6>
              </div>
              <div className="col-md-4">
                <h6><i class="fa-solid fa-square-check px-2" style={{ color: "green" }}></i>Forest Rides</h6>
                <h6><i class="fa-solid fa-square-check px-2" style={{ color: "green" }}></i>Nature Stops</h6>
              </div>
              <div className="col-md-4">
                <h6><i class="fa-solid fa-square-check px-2" style={{ color: "green" }}></i>Jeep Safari</h6>
                <h6><i class="fa-solid fa-square-check px-2" style={{ color: "green" }}></i>Wild Escapes</h6>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Home;